<template>
    <div class="relative mt-5">
        <div v-if="currency" class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span class="text-gray-500 sm:text-md"> £ </span>
        </div>
        <input
            @input="$emit('update:modelValue', $event.target.value); validation?.$touch()"
            @blur="$emit('blur')"
            @change="$emit('change')"
            :type="type"
            :class="[required ? 'placeholder-shown:border-2 placeholder-shown:border-red-500' : '', typeof styling !== 'undefined' ? styling : '', currency ? 'pl-8' : '', validation?.$error ? 'border-red-500 border-2' : '']"
            class="textInput peer h-10 p-2 focus:ring-0 w-full border-gray-300 text-gray-900 placeholder-transparent focus:outline-none focus:border-ap-primary"
            :value="value ?? modelValue"
            :disabled="disabled"
            :readonly="readonly"
            :autocomplete="autocomplete"
            :placeholder="label"
            :name="name"
            :list="list"
            :step="step"
        />
        <label :for="slug" class="textInputLabel peer-placeholder-shown:pl-3 pointer-events-none absolute left-0 text-gray-600 text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 -top-4 pl-0">{{ label }}<span v-if="required" class="text-red-500">*</span></label>
    </div>
    <small class="text-sm text-red-500" v-if="validation?.$error">{{ validation.$errors[0].$message }}</small>
</template>

<script>
export default {
    emits: ['update:modelValue', 'blur'],
    props: {
        label: { type: String, required: true },
        value: { required: false },
        name: { type: String, required: false },
        modelValue: { type: [String, Number], required: false },
        autocomplete: { type: String, default: 'off' },
        type: { type: String, default: 'text' },
        readonly: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        styling: { required: false },
        validation: { type: Object, required: false },
        list: { required: false },
        step: { required: false },
        modelModifiers: {
            default: () => ({}),
        },
        currency: { default: false },
    },
    computed: {
        slug() {
            return this.slugify(this.label);
        },
        required() {
            return this.validation?.required;
        },
    },
    methods: {
        slugify(string) {
            let str = string;
            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();

            // remove accents, swap ñ for n, etc
            const from = 'àáäâèéëêìíïîòóöôùúüûñç·/-,:;';
            const to = 'aaaaeeeeiiiioooouuuunc______';
            for (let i = 0, l = from.length; i < l; i += 1) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '_') // collapse whitespace and replace by -
                .replace(/-+/g, '_'); // collapse dashes

            return str;
        },
    },
};
</script>

<style>

</style>
